module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "Edit-alternative-email modal-card",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.updateEmail($event)
      }
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-body"
  }, [(_vm.success) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(1)]) : (!_vm.success && _vm.user.new_alternative_email) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "content"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.user.alternative_email) ? _vm._m(5) : _vm._e()]), _vm._v(" "), (!_vm.success) ? [_c('b-field', {
    attrs: {
      "type": _vm.error_message ? 'is-danger' : '',
      "message": _vm.$t(_vm.error_message)
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": _vm.$t('modals.alternative_email.placeholder'),
      "type": "email",
      "icon": "email"
    },
    model: {
      value: (_vm.alternative_email),
      callback: function($$v) {
        _vm.alternative_email = $$v
      },
      expression: "alternative_email"
    }
  })], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.alternative_email.$error && !_vm.$v.alternative_email.required),
      expression: "$v.alternative_email.$error && !$v.alternative_email.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('validation.required')) + "\n      ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.alternative_email.$error && !_vm.$v.alternative_email.email),
      expression: "$v.alternative_email.$error && !$v.alternative_email.email"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('validation.email')) + "\n      ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.alternative_email.$error && !_vm.$v.alternative_email.maxLength),
      expression: "$v.alternative_email.$error && !$v.alternative_email.maxLength"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('validation.max.string', {
    max: 190
  })) + "\n      ")])] : _vm._e()], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [(_vm.success) ? _c('button', {
    staticClass: "button is-success is-fullwidth",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "check"
    }
  })], 1) : _c('button', {
    staticClass: "button is-danger is-fullwidth",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('buttons.update')) + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "modal-card-title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('modals.alternative_email.title')) + "\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v(_vm._s(_vm.$t('messages.alternative_email_added')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modals.alternative_email.valid_email', {
        email: _vm.user.new_alternative_email
      }))
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v(_vm._s(_vm.$t('modals.alternative_email.text')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modals.alternative_email.school_email', {
        email: _vm.user.email
      }))
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modals.alternative_email.current_email', {
        email: _vm.user.alternative_email
      }))
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f5333bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalEditAlternativeEmail.vue
// module id = 358
// module chunks = 9